import { graphql } from "../generated";

export const OnAIAnswersGenerated = graphql(`
  subscription OnAIAnswersGenerated($transcriptionId: ID!) {
    onAIAnswersGenerated(transcriptionId: $transcriptionId) {
      transcriptionId
      data {
        callId
        categories {
          categoryId
          questions {
            questionId
            feedback
            questionType
            binaryAnswer
            ratingAnswer
          }
        }
      }
      error {
        name
      }
    }
  }
`);
